import React from "react";
import "./Banner.css";
import { useNavigate } from "react-router";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
const Banner = ({ scrollToMobile }) => {
  const navigate = useNavigate();

  const handleJoinClick = (e) => {
    e.preventDefault();

    if (window.location.pathname === "/") {
      scrollToMobile && scrollToMobile();
    } else {
      navigate("/");
      setTimeout(() => {
        scrollToMobile && scrollToMobile();
      }, 300);
    }
  };

  return (
    <div className="banner-section">
      <div className="banner">
        <div className="banner-overlay">
          <div className="banner-content">
            <h1>
              Become a <br /> CarePreneur Today
            </h1>
            <ButtonComponent title="Join as a Carepreneur Today" onClick={handleJoinClick} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
